@if (buyingPowerDetails) {
  <div class="buying-power" [class.text-color-error]="isBuyingPowerTooLow">
    @if (!buyingPowerDetails.lombardEnabled) {
      <div [class.justify-content-end]="!isLeftAligned" class="d-flex align-items-center" data-zid="lombard-not-enabled">
        {{ 'trade.create.volume.available' | transloco }} {{ buyingPowerDetails.buyingPower | currency
        }}<ng-container *ngTemplateOutlet="infoIcon" />
      </div>
    } @else if (buyingPowerDetails.maxCreditAmount) {
      <!-- There is no active credit but it would be possible to get one with the amount buyingPowerDetails.maxCreditAmount -->
      <div [class.justify-content-end]="!isLeftAligned" class="d-flex align-items-center" data-zid="possible-lombard">
        {{ 'trade.create.volume.available' | transloco }} {{ buyingPowerDetails.buyingPower | currency
        }}<ng-container *ngTemplateOutlet="infoIcon" />
      </div>
      <ng-container
        *ngTemplateOutlet="
          lombardValue;
          context: { value: buyingPowerDetails.maxCreditAmount + buyingPowerDetails.buyingPowerWithoutCredit, displaySuffix: true }
        "
      />
    } @else {
      <div [class.justify-content-end]="!isLeftAligned" class="d-flex align-items-center" data-zid="active-lombard">
        {{ 'trade.create.volume.available' | transloco }} {{ buyingPowerDetails.buyingPowerWithoutCredit | currency
        }}<ng-container
          *ngTemplateOutlet="infoIcon; context: { lombard: buyingPowerDetails.buyingPower - buyingPowerDetails.buyingPowerWithoutCredit }"
        />
      </div>
      <ng-container *ngTemplateOutlet="lombardValue; context: { value: buyingPowerDetails.buyingPower }" />
    }
  </div>
}

<ng-template #lombardValue let-value="value" let-displaySuffix="displaySuffix">
  <div class="mr-4">
    {{ 'trade.create.volume.lombard.prefix' | transloco }}
    <a class="link-secondary cursor-pointer" [routerLink]="lombardUrl">{{ 'trade.create.volume.lombard.label' | transloco }}</a>
    @if (displaySuffix) {
      {{ 'trade.create.volume.lombard.suffix' | transloco }}
    }
    {{ value | currency }}
  </div>
</ng-template>

<ng-template #infoIcon let-lombard="lombard">
  <div class="icon-tooltip-wrapper ml-2 no-select">
    <svg class="icon icon-14 cursor-pointer" (click)="displayTooltip = !displayTooltip">
      <use xlink:href="/assets/img/svgs/svgset.svg#info" />
    </svg>
    @if (displayTooltip) {
      <ng-container *ngTemplateOutlet="tooltip; context: { lombard }" />
    }
  </div>
</ng-template>

<ng-template #tooltip let-lombard="lombard">
  <div class="icon-tooltip-content text-left left-aligned icon-tooltip-content--show autoheight">
    <div class="icon-tooltip-close" (click)="displayTooltip = !displayTooltip">
      <svg class="icon icon-14">
        <use xlink:href="/assets/img/svgs/svgset.svg#close" />
      </svg>
    </div>
    <div class="d-flex">
      <div class="flex-grow">{{ 'trade.create.volume.tooltip.bookedSaldo' | transloco }}</div>
      <div>{{ buyingPowerDetails?.bookedSaldo | currency: 'EUR' : 'symbol' }}</div>
    </div>
    <div class="d-flex">
      <div class="flex-grow">{{ 'trade.create.volume.tooltip.nonBookedCharges' | transloco }}</div>
      <div>{{ buyingPowerDetails?.nonBookedCharges | currency: 'EUR' : 'symbol' }}</div>
    </div>
    <div class="d-flex" [class.border-bottom]="!lombard">
      <div class="flex-grow">{{ 'trade.create.volume.tooltip.blockedThroughOpenBuyOrders' | transloco }}</div>
      <div>{{ buyingPowerDetails?.blockedThroughOpenBuyOrders | currency: 'EUR' : 'symbol' }}</div>
    </div>
    @if (lombard) {
      <div class="d-flex border-bottom" data-zid="tooltip-with-lombard">
        <div class="flex-grow">{{ 'trade.create.volume.tooltip.lombard' | transloco }}</div>
        <div>{{ lombard | currency: 'EUR' : 'symbol' }}</div>
      </div>
    }
    <div class="d-flex">
      <div class="flex-grow"></div>
      <div>{{ buyingPowerDetails.buyingPower | currency: 'EUR' : 'symbol' }}</div>
    </div>
    @if (isBuyingPowerTooLow) {
      <div class="mt-2">{{ 'trade.create.volume.buyingPowerTooLow' | transloco }}</div>
    }
    @if (buyingPowerDetails?.nonBookedCharges !== 0) {
      <div class="mt-2">{{ 'trade.create.volume.tooltip.nonBookedChargesHint' | transloco }}</div>
    }
  </div>
</ng-template>
